import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า HbA1C โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'HbA1C', gender, age, 'HbA1C');
};
